function injectStyle (ssrContext) {
  require("!!style-loader!css-loader!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-1815457b\",\"scoped\":true,\"hasInlineConfig\":false}!postcss-loader!sass-loader!./style.scss")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./script.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1815457b\",\"hasScoped\":true}!./template.html"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1815457b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./app/components/login-modal/index.vue
// module id = 337
// module chunks = 0